var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1755_8113)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58579 2.30007C6.96086 1.92499 7.46957 1.71429 8.00001 1.71429C8.53044 1.71429 9.03915 1.92499 9.41422 2.30007C9.65121 2.53706 9.82258 2.82739 9.91664 3.14286H6.08338C6.17744 2.82739 6.34881 2.53706 6.58579 2.30007ZM4.32993 3.14286C4.45035 2.36938 4.81318 1.64831 5.37361 1.08789C6.07018 0.391326 7.01492 0 8.00001 0C8.98509 0 9.92984 0.391326 10.6264 1.08789C11.1868 1.64831 11.5497 2.36938 11.6701 3.14286H14.8572C15.3305 3.14286 15.7143 3.52662 15.7143 4C15.7143 4.47339 15.3305 4.85714 14.8572 4.85714H13.7143V14.2857C13.7143 14.7403 13.5337 15.1765 13.2122 15.4979C12.8908 15.8194 12.4546 16 12 16H4.00001C3.54534 16 3.10931 15.8194 2.78782 15.4979C2.46634 15.1765 2.28572 14.7403 2.28572 14.2857V4.85714H1.14286C0.669476 4.85714 0.285721 4.47339 0.285721 4C0.285721 3.52662 0.669476 3.14286 1.14286 3.14286H4.32993ZM5.71429 6.71595C6.10878 6.71595 6.42858 7.03576 6.42858 7.43024V12.0034C6.42858 12.3978 6.10878 12.7177 5.71429 12.7177C5.3198 12.7177 5.00001 12.3978 5.00001 12.0034V7.43024C5.00001 7.03576 5.3198 6.71595 5.71429 6.71595ZM11 7.43024C11 7.03576 10.6802 6.71595 10.2857 6.71595C9.89123 6.71595 9.57144 7.03576 9.57144 7.43024V12.0034C9.57144 12.3978 9.89123 12.7177 10.2857 12.7177C10.6802 12.7177 11 12.3978 11 12.0034V7.43024Z",
    fill: "#676C7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1755_8113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconGray);
export default __webpack_public_path__ + "static/media/deleteIconGray.161e6bd0ee833459779a9bafba93c1fc.svg";
export { ForwardRef as ReactComponent };